import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import zasadySerwisuPl from "../content/zasadySerwisuPl";
import "./LegalPage.css";

function ServiceRules() {
  const { locale } = useI18n();

  if (locale === "pl") {
    const sections = zasadySerwisuPl
      .split(/\n+/)
      .map((section) => section.trim())
      .filter(Boolean);
    const tableOfContents = [
      "Podsumowanie polityki prywatności",
      "Informacje dotyczące osób niepełnoletnich",
      "Jak zbieramy dane osobowe",
      "Podstawy prawne przetwarzania danych osobowych",
      "Zbierane informacje",
      "Przetwarzanie zgromadzonych informacji",
      "Ujawnianie informacji",
      "Sprawdzanie i modyfikowanie informacji",
      "Przechowywanie danych osobowych",
      "Brak zgody na przetwarzanie i ograniczenia dotyczące danych osobowych",
      "Łącza do stron internetowych innych firm",
      "Przekazywanie danych osobowych do innych krajów",
      "Zmiany i aktualizacje polityki",
      "Najnowsza wersja i data wejścia w życie",
      "Bezpieczeństwo",
      "Skargi i pytania",
    ];

    return (
      <div className="legal-page">
        <div className="legal-card">
          <Link to="/register" className="legal-back-link">
            ← Powrót do rejestracji
          </Link>

          <h1>{sections[0] || "Zasady serwisu"}</h1>

          <p className="legal-version">
            Aktualna wersja: 2026-08-28
          </p>

          {sections.slice(1).map((section, index) => {
            if (section === "Spis treści") {
              return (
                <section key="table-of-contents">
                  <h2>Spis treści</h2>
                  <ol>
                    {tableOfContents.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ol>
                </section>
              );
            }

            const isTableOfContentsItem =
              index >= 3 &&
              index <= tableOfContents.length + 2 &&
              tableOfContents.includes(section);

            if (isTableOfContentsItem) {
              return null;
            }

            return (
              <section key={`${index}-${section.slice(0, 24)}`}>
                <p>{section}</p>
              </section>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/register" className="legal-back-link">
          ← Back to registration
        </Link>

        <h1>Service Rules</h1>

        <p className="legal-version">
          Current version: 2026-08-28
        </p>

        <section>
          <h2>1. Purpose of the Service</h2>
          <p>
            TajneMysli is an adult educational and entertainment communication
            portal. The service is designed to help users practice social
            interaction, explore conversations, improve communication skills,
            and enjoy game-like chat and matching features. The service is not a
            professional advice platform and should not be used as a substitute
            for legal, medical, psychological, financial, or emergency support.
          </p>
        </section>

        <section>
          <h2>2. Adults Only</h2>
          <p>
            The service is only for users who are 18 years old or older. By
            using TajneMysli, you confirm that you meet this age requirement. Users
            under 18 are not allowed to create accounts, browse profiles, match,
            chat, or use any other feature of the service.
          </p>
        </section>

        <section>
          <h2>3. Respectful Communication</h2>
          <p>
            Users must communicate respectfully. Harassment, threats, insults,
            hate speech, sexual exploitation, manipulation, blackmail, bullying,
            or abusive behavior are not allowed. The service is intended for
            entertainment, education, and communication practice, not for harming
            or pressuring other people.
          </p>
        </section>

        <section>
          <h2>4. Chat With Users and AI Models</h2>
          <p>
            Users may chat with available profiles inside the service. Some
            profiles may represent real users, while others may be AI model
            profiles or automated conversational models. Users can interact with
            available chat participants on equal terms within the rules of the
            service. AI model profiles are provided for entertainment,
            educational practice, role-play, and communication training.
          </p>
        </section>

        <section>
          <h2>5. AI Conversations</h2>
          <p>
            AI-generated messages may be fictional, inaccurate, incomplete, or
            created for entertainment. AI model profiles do not provide
            professional advice, guaranteed facts, or real-world commitments.
            Users should not rely on AI messages for important decisions.
            Conversations with AI models should be treated as educational and
            entertainment interactions.
          </p>
        </section>

        <section>
          <h2>6. Tokens</h2>
          <p>
            TajneMysli uses Tokens as virtual units for certain features. Tokens are
            used inside the service and do not represent money, bank credit, or
            any external financial instrument. Tokens may be required for chat
            messages, match limit refreshes, or other in-service features.
          </p>
        </section>

        <section>
          <h2>7. Starting Tokens</h2>
          <p>
            Each new registered user receives 100 Tokens at the start. These
            Tokens are provided so the user can try the service and begin using
            chat features. The starting Token amount may be changed for future
            users, promotions, or technical tests.
          </p>
        </section>

        <section>
          <h2>8. Chat Message Cost</h2>
          <p>
            Sending one message in chat costs 20 Tokens. When a user sends a
            message, the system may deduct 20 Tokens from the user&apos;s
            balance. If the user does not have enough Tokens, the message may
            not be sent until the user receives or purchases more Tokens,
            depending on the available features.
          </p>
        </section>

        <section>
          <h2>9. Daily Match Limit</h2>
          <p>
            Users can match with up to 20 users per day. This daily limit helps
            protect the service from spam and keeps the experience fair for
            other users. The daily limit may reset automatically according to
            the system schedule used by the service.
          </p>
        </section>

        <section>
          <h2>10. Match Limit Refresh</h2>
          <p>
            If a user wants to continue matching after reaching the daily limit,
            the user may buy a one-time match limit refresh for 50 Tokens. This
            refresh can be purchased multiple times. Each purchase deducts 50
            Tokens from the user&apos;s balance and allows additional matching
            according to the rules displayed in the application.
          </p>
        </section>

        <section>
          <h2>11. Fair Use</h2>
          <p>
            Users must use the service fairly. Automated scraping, spam,
            artificial account creation, attempts to manipulate matches,
            attempts to obtain free Tokens without authorization, abuse of
            technical errors, or attempts to bypass service limits are not
            allowed. Accounts involved in unfair use may be restricted,
            suspended, or removed.
          </p>
        </section>

        <section>
          <h2>12. Prohibited Content</h2>
          <p>
            Users must not upload, send, or share illegal, violent, hateful,
            abusive, misleading, fraudulent, or harmful content. Content that
            exploits minors, promotes illegal activity, violates privacy, or
            infringes another person&apos;s rights is strictly prohibited. The
            service may remove content that violates these rules.
          </p>
        </section>

        <section>
          <h2>13. No Impersonation or Fraud</h2>
          <p>
            Users must not impersonate another person, create misleading
            profiles, pretend to represent the service without permission, scam
            other users, request money through deception, or use the platform to
            commit fraud. Profile information should not be used to mislead or
            harm others.
          </p>
        </section>

        <section>
          <h2>14. Personal Information and Safety</h2>
          <p>
            Users should be careful when sharing personal information. Do not
            share sensitive details such as passwords, payment information,
            private addresses, identity documents, or other confidential data in
            chat. The service may include entertainment conversations, including
            AI conversations, and users are responsible for protecting their own
            privacy.
          </p>
        </section>

        <section>
          <h2>15. Reporting Problems</h2>
          <p>
            If a user sees abusive behavior, suspicious activity, technical
            problems, payment issues, or content that may violate these rules,
            the user should contact the service administrator. Reports may be
            reviewed to improve safety and protect the platform.
          </p>
        </section>

        <section>
          <h2>16. Enforcement</h2>
          <p>
            The service may enforce these rules by warning users, removing
            content, limiting features, reducing access, suspending accounts, or
            terminating accounts. Enforcement decisions may depend on the
            severity of the violation, repeated behavior, technical evidence,
            user reports, and the need to protect the service.
          </p>
        </section>

        <section>
          <h2>17. Changes to Service Rules</h2>
          <p>
            These Service Rules may be updated as the platform grows, adds new
            features, changes Token mechanics, improves safety systems, or
            updates legal requirements. The current version is displayed on this
            page. Users may be asked to accept updated terms or rules when
            required.
          </p>
        </section>

        <section>
          <h2>18. Summary</h2>
          <p>
            Use TajneMysli responsibly, be respectful, remember that the service is
            for adults only, treat AI conversations as entertainment and
            educational practice, follow the Token rules, and do not abuse the
            platform or other users.
          </p>
        </section>
      </div>
    </div>
  );
}

export default ServiceRules;
